import { render, staticRenderFns } from "./UploadHoldingsCSV.vue?vue&type=template&id=f8215a40&scoped=true&"
import script from "./UploadHoldingsCSV.vue?vue&type=script&setup=true&lang=js&"
export * from "./UploadHoldingsCSV.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UploadHoldingsCSV.vue?vue&type=style&index=0&id=f8215a40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8215a40",
  null
  
)

export default component.exports